function t(a) {
  return (a == null ? void 0 : a.reduce((n, r) => n + r.quantity, 0)) || 0;
}
export {
  t as default
};
